module.exports = __webpack_public_path__ + "img/02-2.eb540ef5.png";